export var resolveLoggerConfig = function resolveLoggerConfig(input) {
  return input;
};